"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const DragAndDrop_vue_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/components/DragAndDrop.vue"));
const WorkflowOptionDrawSelect_vue_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/components/WorkflowOptionDrawSelect.vue"));
const WorkflowOptionProviders_vue_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/components/WorkflowOptionProviders.vue"));
const FieldsSetupFlowController_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/modules/controllers/FieldsSetupFlowController"));
const ProviderFields_vue_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/components/modals/ProviderFields.vue"));
const ProviderItem_vue_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/components/ProviderItem.vue"));
let WorkflowSteps = class WorkflowSteps extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.FIELDS_SETUP_FLOW_CONTROLLER = FieldsSetupFlowController_1.default.getInstance();
        this.STEP_CONTROLLER = this.FIELDS_SETUP_FLOW_CONTROLLER.workflowStep;
        this.isProviderFieldsModal = false;
        this.currentProvider = null;
    }
    get providers() {
        return this.FIELDS_SETUP_FLOW_CONTROLLER.providers;
    }
    changeToVardaStep() {
        this.FIELDS_SETUP_FLOW_CONTROLLER.vardaStep.data.selectedFields = [];
        this.FIELDS_SETUP_FLOW_CONTROLLER.setCurrentStep(this.FIELDS_SETUP_FLOW_CONTROLLER.vardaStep);
        this.trackStepAsCompleted('varda');
    }
    deployProviderFieldsModal(provider) {
        this.currentProvider = provider;
        this.isProviderFieldsModal = true;
        this.trackStepAsCompleted(`integration-${provider.name.toLowerCase()}`);
    }
    closeProviderFieldsModal() {
        this.isProviderFieldsModal = false;
        this.providers.forEach((provider) => {
            provider.reset();
        });
    }
    trackStepAsCompleted(workflow) {
        let mode = (this.FIELDS_SETUP_FLOW_CONTROLLER.isAddingFields) ? 'Edition' : 'Setup';
        this.$emit('logActivity', {
            name: `Farm ${mode} Step 1 Completed: Workflow Selection`,
            status: 'ok',
            props: {
                workflow: workflow
            }
        });
    }
};
WorkflowSteps = __decorate([
    (0, vue_property_decorator_1.Options)({ components: { DragAndDrop: DragAndDrop_vue_1.default, WorkflowOptionDrawSelect: WorkflowOptionDrawSelect_vue_1.default, WorkflowOptionProviders: WorkflowOptionProviders_vue_1.default, ProviderFieldsModal: ProviderFields_vue_1.default, ProviderItem: ProviderItem_vue_1.default } })
], WorkflowSteps);
exports.default = WorkflowSteps;
